/** Feature flags de producto. La multi-entidad se oculta hasta que el cliente la pida. */
export const MULTI_ENTITY_ENABLED = false;

export const DEFAULT_ENTITY_NAME = 'ASOCIACION';
export const DEFAULT_ENTITY_CODE = 'ASOC';

export function normalizeEntityLabel(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

function matchesAssociation(name?: string | null, code?: string | null): boolean {
  const n = normalizeEntityLabel(name || '');
  const c = normalizeEntityLabel(code || '');
  return n === 'asociacion' || n.includes('asociacion') || c === 'asoc';
}

/** Elige ASOCIACION; si no existe en la lista, cae al primer elemento. */
export function pickDefaultEntity<T extends {
  entity_id?: number;
  id?: number;
  entity_name?: string | null;
  name?: string | null;
  code?: string | null;
}>(entities: T[]): T | undefined {
  if (entities.length === 0) return undefined;
  return entities.find((e) => matchesAssociation(e.entity_name ?? e.name, e.code)) ?? entities[0];
}
